"use strict";var a=(l=>(l.Vertical="Vertical",l.Horizontal="Horizontal",l))(a||{});export default a;
//# sourceMappingURL=Orientation.js.map
